import { Component, OnDestroy, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { CommonService } from './services/common/common.service';
import { UserInactivityService } from './services/user-inactivity/user-inactivity.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
  environment = environment;

  constructor(
    private titleService: Title,
    private commonService: CommonService,
    private userInactivityService: UserInactivityService,
  ){};

  ngOnInit(): void {
    this.commonService.loadNotificationsFromStorage();
    this.userInactivityService.start();

    switch(environment.name){
      case 'local':
        this.titleService.setTitle('Local - DTx Studio');
        break;
      case 'dev':
        this.titleService.setTitle('Dev - DTx Studio');
        break;
      case 'stage':
        this.titleService.setTitle('Stage - DTx Studio');
        break;
      case 'pre-prod':
        this.titleService.setTitle('Pre-prod - DTx Studio');
        break;
      case 'production':
        this.titleService.setTitle('DTx Studio');
        break;
    }
  }

  ngOnDestroy(): void {
    this.userInactivityService.stop();
  }
}
